import { createSelector } from 'reselect';
import {
    getAppliedSideFiltersSelector,
    getCurrentFilterPageSelector,
    getSideFiltersSelector,
    getTopFiltersSelector,
} from '../../../common/components/SideFilters/data/selectors';
import {
    getLocationSelector,
    getSelectedOptionByPageSelector,
    getCachedLastAppliedTopFiltersOptionSelector,
} from '../../../common/components/TopFilter/data/selectors';
import { TOP_FILTERS_OPTION_BE_KEY } from '../../../common/components/TopFilter/utils/constants';

export const getComputedFiltersParametersForBrandUpload = createSelector(
    [
        getTopFiltersSelector,
        getCachedLastAppliedTopFiltersOptionSelector,
        getAppliedSideFiltersSelector,
        getCurrentFilterPageSelector,
        getSelectedOptionByPageSelector,
        getLocationSelector,
        getSideFiltersSelector,
    ],
    (topFilters, cachedSelectedOption, filters, currentPage, selectedOptionsByPage, location) => {
        try {
            let filtersList = [];

            let selectedTopFiltersOption;

            selectedTopFiltersOption = selectedOptionsByPage[location];

            const topFilterGroupId = topFilters?.filter(el =>
                el.group.toLowerCase().includes(TOP_FILTERS_OPTION_BE_KEY[location])
            )[0]?.id;
            /*If current state of the top filters do represent a set of filters with an option selected
                retrieve last working filtres from cache */
            if (!selectedTopFiltersOption.length) {
                const cachedOptions = cachedSelectedOption[location]?.filter(el =>
                    el.group.toLowerCase().includes(TOP_FILTERS_OPTION_BE_KEY[location])
                );
                selectedTopFiltersOption = cachedOptions;
            }

            /* Add parameters from top filters */
            if (selectedTopFiltersOption) {
                let ids = [];
                let groupId = null;

                selectedTopFiltersOption.forEach(el => {
                    ids.push(el.id);
                    if (!groupId) {
                        groupId = topFilterGroupId || el.groupId; //Apply the last working group from cache if user comes from a section that has a different group BE key
                    }
                });

                filtersList.push({ ID: '' + groupId, List: ids });
            }
            return filtersList;
        } catch (error) {}
    }
);
